export default __webpack_public_path__ + "static/revamping-central-reserve-system-for-a-sydeny-based-hosptiality-group-5d403c33ec339eaf878dbbd958f80ab7.jpg";